<div app-lomake-62-oy-2025 (tallennaArvo)="lomakeMuuttui($event)" (sulje)="sulje()" [veroilmoitusObservable]="veroilmoitusObservable" class="blue-block"></div>
